import Person from "@/models/api/person/Person";
import PersonRegistrationRequest from "@/models/api/person/PersonRegistrationRequest";
import axios, { AxiosResponse } from "axios";
import SelectListItem from '../models/SelectListItem';
class Service {
    public async EditPerson(person: Person, emailConfirmUrl: string): Promise<AxiosResponse<any>> {
        return axios.post("api/person/EditPerson/", person, {
                params: {
                    emailConfirmUrl: emailConfirmUrl         
                }
            }
        );
    }

    
    public async GetPersonsForAddToGroup(groupId: number | null): Promise<AxiosResponse<Person[]>> {
        if (groupId) {
            return axios.get(`api/person/GetPersonsForAddToGroup/?groupId=${groupId}`);
        }

        return axios.get(`api/person/GetPersonsForAddToGroup/`);
    }

    public async GetPersons(): Promise<AxiosResponse<[]>>  {
        return axios.get('api/person/GetPersons/');
    }

    public async GetPersonsPaged(data: any): Promise<AxiosResponse<any>> {
        return axios.post('api/person/GetPersonsPaged', data);
    }
    public async GetPerson(id: number): Promise<AxiosResponse<any>> {
        return axios.get(`api/person/${id}`);
    }

    public async RegisterPerson(personData: PersonRegistrationRequest, emailConfirmUrl: string, returnPersonId: boolean = false): Promise<AxiosResponse<any>> {
        return axios.post("api/person/RegisterPerson/", personData, {
            params: {
                emailConfirmUrl: emailConfirmUrl,
                returnPersonId: returnPersonId               

            }
        });
    }

    public async RemovePerson(id: number): Promise<AxiosResponse<any>> {
        return axios.delete(`api/person/RemovePerson?id=${id}`);
    }

    public async GetAssociationsGroupsSelectListItems(searchText?: string): Promise<AxiosResponse<SelectListItem[]>> {
        if (searchText) {
            return axios.get(`api/person/GetAssociationsGroupsSelectListItems/?searchText=${searchText}`);
        }

        return axios.get('api/person/GetAssociationsGroupsSelectListItems/');
    }

    public async GetPersonsFromFile(file: FormData ): Promise<AxiosResponse<any>>{
        return axios.post('api/person/GetPersonsFromFile/',file);
    }

    public async HandleImport(persons: Person[]): Promise<AxiosResponse<any>> {
        return axios.post("api/person/HandleImport/", persons);
    }
}

export const PersonService: Service = new Service();
